import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';


import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxEchartsModule } from 'ngx-echarts';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from "@angular/material/card";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";

import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { HighlightSearch } from "../shared/pipes/highlight.pipe";
import { PhonePipe } from "../shared/pipes/phone.pipe";
import { AdvancedCompanyFilterComponent } from './components/advanced-company-filter/advanced-company-filter.component';
import { AdvancedContactFilterComponent } from './components/advanced-contact-filter/advanced-contact-filter.component';
import { AdvancedFilterCheckboxListComponent } from './components/advanced-filter-checkbox-list/advanced-filter-checkbox-list.component';
import { AuthAsComponent } from './components/auth-as/auth-as.component';
import { ChipsAutocompleteInputComponent } from './components/chips-autocomplete-input/chips-autocomplete-input.component';
import { CompanyEditDialogComponent } from './components/company-edit-dialog/company-edit-dialog.component';
import { CompanySearchContentComponent } from './components/company-search-content/company-search-content.component';
import { CompanySearchResultTagsComponent } from './components/company-search-result-tags/company-search-result-tags.component';
import { CompanySearchWidgetComponent } from './components/company-search-widget/company-search-widget.component';
import { CompanySurveyDialogComponent } from './components/company-survey-dialog/company-survey-dialog.component';
import { CompanySurveyViewDialogComponent } from './components/company-survey-view-dialog/company-survey-view-dialog.component';
import { ContactEditDialogComponent } from './components/contact-edit-dialog/contact-edit-dialog.component';
import { ContactSearchContentComponent } from './components/contact-search-content/contact-search-content.component';
import { ContactSearchResultTagsComponent } from './components/contact-search-result-tags/contact-search-result-tags.component';
import { SaveSearchComponent } from './components/dialog/save-search/save-search.component';
import { FacilitateMeetingDialogComponent } from './components/facilitate-meeting-dialog/faciltiate-meeting-dialog.component';
import { FacilitateMeetingRateDialogComponent } from './components/facilitate-meeting-rate-dialog/facilitate-meeting-rate-dialog.component';
import { FilterCheckboxListComponent } from './components/filter-checkbox-list/filter-checkbox-list.component';
import { FilterDomainListComponent } from './components/filter-domain-list/filter-domain-list.component';
import { HeaderComponent } from './components/header/header.component';
import { LocationFilterComponent } from './components/location-filter/location-filter.component';
import { MeetingDialogComponent } from './components/meeting-dialog/meeting-dialog.component';
import { MeetingTableComponent } from './components/meeting-table/meeting-table.component';
import { PagerComponent } from './components/pager/pager.component';
import { SearchWebsitesTagsDialogComponent } from './components/search-websites-tags-dialog/search-websites-tags-dialog.component';
import { StopPropagationDirective } from './components/stop-propagation.directive';
import { ToastComponent } from './components/toast/toast.component';
import { MaterialModule } from './material.module';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import * as echarts from 'echarts';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AutoOpenMenuComponent } from './components/auto-open-menu/auto-open-menu.component';
import { ClearbitLogoComponent } from './components/clearbit-logo/clearbit-logo.component';
import { IndustryFilterAutocompleteComponent } from './components/industry-filter-autocomplete/industry-filter-autocomplete.component';
import { AddDirectReportComponent } from './components/org-chart/modals/add-direct-report/add-direct-report.component';
import { OrgChartComponent } from './components/org-chart/org-chart.component';
import { ProductCategoriesMenuComponent } from './components/product-categories-menu/product-categories-menu.component';
import { ProfilePictureComponent } from './components/profile-picture/profile-picture.component';
import { ProfileSkillsComponent } from './components/profile-skills/profile-skills.component';
import { SearchFilterAutocompleteIncludeExcludeComponent } from './components/search-filter-autocomplete-include-exclude/search-filter-autocomplete-include-exclude.component';
import { SearchFilterAutocompleteJsonComponent } from './components/search-filter-autocomplete-json/search-filter-autocomplete-json.component';
import { SearchFilterAutocompleteStacksComponent } from './components/search-filter-autocomplete-stacks/search-filter-autocomplete-stacks.component';
import { SearchFilterAutocompleteSwitchComponent } from './components/search-filter-autocomplete-switch/search-filter-autocomplete-switch.component';
import { SearchFilterAutocompleteComponent } from './components/search-filter-autocomplete/search-filter-autocomplete.component';
import { SearchFilterCheckboxListComponent } from './components/search-filter-checkbox-list/search-filter-checkbox-list.component';
import { SearchFilterCompanyComponent } from './components/search-filter-company/search-filter-company.component';
import { SearchFilterQualityLevelComponent } from './components/search-filter-quality-level/search-filter-quality-level.component';
import { SearchFilterRangeComponent } from './components/search-filter-range/search-filter-range.component';
import { SearchFilterSliderIntensityComponent } from './components/search-filter-slider-intensity/search-filter-slider-intensity.component';
import { SearchFilterSliderLastVerifiedComponent } from './components/search-filter-slider-last-verified/search-filter-slider-last-verified.component';
import { SearchFilterComponent } from './components/search-filter/search-filter.component';
import { DoubleClickDirective } from './directives/double-click.directive';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { RemoveBeforeColonPipe } from './pipes/removeBeforeColon.pipe';
import { SafeHtmlPipe } from './pipes/safe-html-pipe';
import { TruncatePipe } from './pipes/trunctate.pipe';



const COMPONENTS = [
  HeaderComponent,
  ContactSearchContentComponent,
  SaveSearchComponent,
  FilterCheckboxListComponent,
  CompanySearchContentComponent,
  ContactSearchResultTagsComponent,
  CompanySearchResultTagsComponent,
  PagerComponent,
  AdvancedCompanyFilterComponent,
  AdvancedContactFilterComponent,
  AdvancedFilterCheckboxListComponent,
  LocationFilterComponent,
  ToastComponent,
  StopPropagationDirective,
  ChipsAutocompleteInputComponent,
  CompanySurveyDialogComponent,
  SearchFilterAutocompleteComponent,
  SearchFilterCheckboxListComponent,
  SearchFilterQualityLevelComponent,
  OrgChartComponent,
  SearchFilterCompanyComponent,
  ProfilePictureComponent,
  SearchFilterComponent,
  SearchFilterRangeComponent,
  SearchFilterAutocompleteJsonComponent,
  ProfileSkillsComponent,
  SearchFilterAutocompleteSwitchComponent,
  SearchFilterAutocompleteIncludeExcludeComponent,
]

@NgModule({
  declarations: [
    ...COMPONENTS,
    CompanySurveyViewDialogComponent,
    MeetingDialogComponent,
    FacilitateMeetingDialogComponent,
    FacilitateMeetingRateDialogComponent,
    MeetingTableComponent,
    PhonePipe,
    HighlightSearch,
    CompanySearchWidgetComponent,
    FilterDomainListComponent,
    SearchWebsitesTagsDialogComponent,
    CompanyEditDialogComponent,
    ContactEditDialogComponent,
    AuthAsComponent,
    DoubleClickDirective,
    ClearbitLogoComponent,
    ProductCategoriesMenuComponent,
    TruncatePipe,
    SearchFilterAutocompleteStacksComponent,
    AutoOpenMenuComponent,
    SearchFilterSliderIntensityComponent,
    SearchFilterSliderLastVerifiedComponent,
    SearchFilterQualityLevelComponent,
    LinkifyPipe,
    RemoveBeforeColonPipe,
    AddDirectReportComponent,
    SafeHtmlPipe,
    IndustryFilterAutocompleteComponent
  ],
    exports: [

        //Components
        ...COMPONENTS,

        //Modules
        FontAwesomeModule,
        NgxEchartsModule,
        RouterModule,
        NgbNavModule,
        MaterialModule,
        MatStepperModule,
        MeetingTableComponent,
        PhonePipe,
        TruncatePipe,
        HighlightSearch,
        ClearbitLogoComponent,
        ProductCategoriesMenuComponent,
        SearchFilterAutocompleteStacksComponent,
        FilterDomainListComponent,
        LinkifyPipe,
        RemoveBeforeColonPipe,
        SafeHtmlPipe,
        IndustryFilterAutocompleteComponent
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        RouterModule,
        NgbNavModule,
        MatCardModule,
        MatSelectModule,
        MatProgressBarModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatTreeModule,
        DragDropModule,
        MatTooltipModule,
        NgxSliderModule,
        NgxEchartsModule.forRoot({ echarts }),
        SimplebarAngularModule,
        MatChipsModule,
        NgOptimizedImage,
        MatBadgeModule,
    ]
})
export class SharedModule { }
